module.exports = __webpack_public_path__ + "img/李小玲.9763447c.jpg";